import React, { useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { brand, hiddenContent, spacer, toggle } from "./styles.module.scss"
import { renderIf } from "../FeatureToggle/FeatureToggle"
import Row from "../layout/Row/Row"
import Icon from "../layout/icon"
import { logAnalyticsEvent } from "../../utils/analytics"

const logClickEvent = (clickEvent) =>
  clickEvent ? logAnalyticsEvent(clickEvent.name, clickEvent.properties) : null

export default function ShowMore({
  moreTitle,
  lessTitle,
  moreTitleText,
  lessTitleText,
  clickEvent,
  children,
}) {
  const [open, setOpen] = useState(false)
  const toggleOpen = () => {
    if (!open) {
      logClickEvent(clickEvent)
    }
    setOpen(!open)
  }

  const RenderIfOpen = renderIf(open)
  const RenderIfClosed = renderIf(!open)

  return (
    <>
      <RenderIfOpen>{children}</RenderIfOpen>
      <RenderIfClosed>
        <div className={hiddenContent}>{children}</div>
      </RenderIfClosed>
      <Row>
        <button
          type="button"
          onClick={toggleOpen}
          title={open ? lessTitleText : moreTitleText}
          className={classNames(toggle, brand)}
        >
          <Row>
            {open ? lessTitle : moreTitle}
            <div className={spacer}>
              <Icon icon={open ? faChevronUp : faChevronDown} />
            </div>
          </Row>
        </button>
      </Row>
    </>
  )
}

ShowMore.propTypes = {
  moreTitle: PropTypes.node.isRequired,
  lessTitle: PropTypes.node.isRequired,
  moreTitleText: PropTypes.string.isRequired,
  lessTitleText: PropTypes.string.isRequired,
  clickEvent: PropTypes.shape({
    name: PropTypes.string,
    properties: PropTypes.object,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

ShowMore.defaultProps = {
  clickEvent: undefined,
}
